/**
 * VEC-3313 — declaración de los filtros de la grilla de Stock por Depósito para <GridFilterPanel />.
 *
 * Vive en su propio módulo porque lo consumen DOS lados: `InventarioStockGridFiltros` (para
 * renderizar) e `InventarioStockGrid` (para calcular el query por defecto con las MISMAS reglas de
 * serialización que aplica el panel). Es el patrón de `movilesFilterFields.js` /
 * `ticketsFilterFields.js`; ver docs/design-system/grid-filter-panel.md.
 *
 * ALCANCE: el Scenario 01 pide "filtro de depósito" y nada más; los tres de texto son la
 * identificación del ítem dentro de ese depósito. Categoría, subcategoría, marca y estado de alerta
 * los ACEPTA el endpoint (ItemStockValidation::getGrid) pero NO se declaran acá: no los pide ningún
 * scenario y sumarlos sería alcance que la card no pidió. El día que se pidan, es agregar entradas
 * a esta lista y nada más — el backend ya está.
 *
 * UNA CLAVE DEL QUERY NO ES UN CAMPO DEL PANEL: `ubicacionType`, que lo agrega la grilla. La
 * ubicación viaja como PAR (tipo + id) porque la columna de la base es polimórfica, y el backend
 * rechaza el par a medias con 400 (ItemStockService::normalizarUbicacion). Como el tipo no es una
 * decisión del usuario —hoy el único es 'almacen'— no tiene control propio: lo deriva
 * `InventarioStockGrid::getQuery()` de que haya un depósito elegido.
 */

export const INVENTARIO_STOCK_FILTROS_STORAGE_KEY = 'InventarioStockGrid_filtros';

/**
 * La grilla abre SIN filtros: el consolidado de todos los depósitos, que es lo que el Scenario 01
 * describe como estado inicial ("el detalle por depósito" se obtiene al filtrar). Se expone igual
 * como función para que la grilla y el panel usen la misma fuente y el reset tenga a dónde volver.
 */
export const getInventarioStockFilterDefaults = () => ({});

const ANCHO_MEDIO = { xs: 12, sm: 6, md: 3, lg: 3 };

export const buildInventarioStockFilterFields = () => [
	{
		// `select` y no `multiselect`: el endpoint valida `ubicacionId` como id ÚNICO
		// (ItemStockValidation::idFiltro). Es a propósito — las tres columnas de stock son la
		// existencia EN un depósito, y sumar dos depósitos en una fila no tiene lectura útil.
		// (El historial global de VEC-3315 sí lo acepta múltiple: ahí cada fila es un movimiento.)
		name: 'ubicacionId',
		type: 'select',
		messageId: 'inventarioStock.grid.filtros_deposito',
		label: 'Depósito',
		size: ANCHO_MEDIO,
	},
	{
		name: 'numeroDeParte',
		type: 'text',
		messageId: 'inventarioStock.grid.filtros_numero_de_parte',
		label: 'Nº de parte',
		size: ANCHO_MEDIO,
	},
	{
		name: 'externalCode',
		type: 'text',
		messageId: 'inventarioStock.grid.filtros_codigo_externo',
		label: 'Código externo',
		size: ANCHO_MEDIO,
	},
	{
		name: 'descripcion',
		type: 'text',
		messageId: 'inventarioStock.grid.filtros_descripcion',
		label: 'Descripción',
		size: ANCHO_MEDIO,
	},
];
